import { ValidationMessages } from "@/types/functions";

const validationEn: ValidationMessages = {
    'min_length': '{field} πρέπει να έχει τουλάχιστον 0:{min} Στοιχεία επιλεγμένα',
    'max_length': '{field} δεν πρέπει να έχει περισσότερα από 0:{max} Στοιχεία επιλεγμένα',
    'multiple': 'Το {field} πρέπει να είναι πολλαπλάσιο του 0:{multiple}.'
}

export default validationEn
